import { EntityView } from '@/common/entityFramework/entityView/EntityView';
import { Route } from 'react-router-dom';
import { GilMnSapComplReconPerspective } from './entities/mnSapComplRecon/GilMnSapComplReconPerspective';
import { GilMnSapSoxReconPerspective } from './entities/mnSapSoxRecon/GilMnSapSoxReconPerspective';

const gilGpRoutes = [
  <Route path="gp/mn-sap-sox-recon" element={<EntityView perspectiveComponent={GilMnSapSoxReconPerspective} />} />,
  <Route path="gp/mn-sap-compl-recon" element={<EntityView perspectiveComponent={GilMnSapComplReconPerspective} />} />,
]

export default gilGpRoutes;